import { Grid, Link, Menu } from '@material-ui/core';
import { sanlamDarkerBlue, white } from 'Material-UI/colors';
import styled from 'styled-components';

export const IconContainer = styled(Grid)`
  align-self: flex-start;
`;

export const StyledMenu = styled(Menu)`
  &&& {
    ul {
      padding: 0px;
    }
    li {
      padding: 0 14px;
    }
    .MuiRadio-colorSecondary.Mui-checked {
      color: #32c284;
    }
  }
`;
export const Container = styled(Grid)`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 15%, #000000 116%);
  height: 78px !important;
  margin-top: 0px !important;
  padding: 0px !important;
  position: absolute !important;
`;

export const OcpLink = styled(Link)`
  cursor: pointer;
  padding: 4px;
  text-align: center;
  background-color: ${white};
  border-radius: 5px;
  text-transform: none;
  max-height: 50px;
`;

export const OcpLinkText = styled(Grid)`
  text-transform: none;
  color: ${sanlamDarkerBlue};
  font-family: 'Roboto' !important;
  font-size: 14px !important;
  text-decoration: underline;
  font-weight: bold;
`;

export const IconGrid = styled(Grid)`
  margin-right: 2px !important;
`;
